"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  id: 1,
  name: "Dr. Ahmad Rizki, S.H., M.H.",
  position: "Managing Partner",
  specialization: "Criminal Law & Litigation",
  description: "Over 15 years of experience in handling complex criminal cases",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541685/img/ahmad_rizki_partner.png",
  isSpecial: false
}, {
  id: 2,
  name: "Siti Nurhaliza, S.H., M.H.",
  position: "Senior Partner",
  specialization: "Civil Law & Land",
  description: "Specialist in land dispute resolution and property matters",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541685/img/siti_nurhaliza_senior.png",
  isSpecial: false
}, {
  id: 3,
  name: "Budi Santoso, S.H., M.H.",
  position: "Partner",
  specialization: "Business & Corporate Law",
  description: "Expert in corporate law and cross-border business transactions",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541685/img/budi_santoso_partner.png",
  isSpecial: false
}, {
  id: 4,
  name: "Maya Kusuma, S.H., M.H.",
  position: "Associate Partner",
  specialization: "Employment Law",
  description: "Experienced in industrial relations and termination settlements",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541685/img/maya_kusuma_associate.png",
  isSpecial: true
}];
export default function Team() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="team" className="dark bg-background text-foreground py-20 px-4" ref={ref}>
      <div className="max-w-screen-xl mx-auto">
        <div className={`text-center mb-16 transition-all duration-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-5xl font-extrabold mb-4 !text-[hsl(35,88%,47%)]">Tim Profesional Kami</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">Para ahli hukum berpengalaman dengan latar belakang akademik dan praktis yang luas</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, i) => <Card key={member.id} data-index={i} className={`group overflow-hidden relative transition-all duration-300 hover:shadow-strong hover:-translate-y-2 ${member.isSpecial ? "bg-gradient-to-b from-[#2D3748] to-[#3182CE]" : "bg-secondary"} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
        }}>
              <CardContent className="p-0">
                <div className="relative overflow-hidden">
                  <SafeHydrate><Avatar className="w-full h-64 rounded-none rounded-t-xl">
                    <AvatarImage src={member.image} alt={member.name} className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105" />
                    <AvatarFallback className="w-full h-full rounded-none bg-muted flex items-center justify-center text-4xl font-bold text-muted-foreground">
                      {member.name.charAt(0)}
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                  <div className="absolute inset-0 bg-gradient-to-t from-[rgba(17,25,39,0.8)] to-transparent pointer-events-none" />
                </div>

                <div className="p-6 transition-transform duration-300 group-hover:-translate-y-2">
                  <h3 className="text-xl font-semibold text-foreground mb-2">
                    {member.name}
                  </h3>
                  <p className="text-base text-muted-foreground mb-1">
                    {member.position}
                  </p>
                  <p className="text-base text-muted-foreground mb-3">
                    {member.specialization}
                  </p>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {member.description}
                  </p>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}